<template>
  <div class="pb-panel-message">
    <p class="pb-panel-message-content">
      <slot />
    </p>
  </div>
</template>

<style lang="scss" src="./PanelMessage.scss" />
